export default {
    auditStatus: [
        'Under review',
        'Approved',
        'Not approved'
    ],
    stage: [
        'To start',
        'Has begun',
        'Has ended',
        'Cancel'
    ],
    onlineConference: 'Online Meeting',
    myFound: 'I created',
    mySubscribe: 'My Bookings',
    shareType: [
        'Directly to join',
        'Sweep and join',
        'Enter the room number to join',
        'H5 Link join'
    ],
    realPersonTabs: [
        'All',
        'No response',
        'Agree',
        'Denied',
        'Application List'
    ],
    'Customer Pool': 'Customer pool',
    'Enterprise Staff': 'Enterprise staff',
    'accepted': [
        'No response',
        'Agree',
        'Denied'
    ]
}
